import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';


// this needed only in case of using the thank you page, 
// which is not the case for the current jotForms implementation
// use case is when the form submission uses POST redirect

class JotFormThankYou extends React.Component {
    static defaultProps = {
        delay: 5000,
      };
    componentDidMount() {
        if (window.parent) {
            window.parent.postMessage({ thankYou: true }, '*');
        }
    }

    render() {
        return (
            <div div className="p-4 text-center">
                <h1>Thank You!</h1>
                <p>Your submission has been received successfully.</p>
                <p>We appreciate your time.</p>
                <Link component={Button} to="/" className="mt-4">Return to home</Link>
            </div>
        );
    }
}

export default withRouter(JotFormThankYou);
